import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actionTypes from "../../../store/Actions/actions";
import "./LinkOption.scss";
import * as UTILS from "../../../utils/Utils"

import { Title } from './components/common/Title';
import { Footer } from './components/common/Footer';
import { ErrorMessage } from './components/common/ErrorMessage';
import { AddAnchor, AttachFile, Email2AFriend, LinkEmail, LinkName, LinkTarget, LinkToPage, LinkToResponse, LinkUrl } from './components';

import { validateEmailFormat, validateURLFormat } from "../../../utils/Utils";
import { filterLayout } from '../../../utils/layout';

const LinkOption = (props) => {
  const [linkName, setLinkName] = useState("");
  const [linkType, setLinkType] = useState("");
  const [link, setLink] = useState(null);
  const [linkOpen, setLinkOpen] = useState("");

  const [emailLink, setEmailLink] = useState("")
  const [urlLink, setUrlLink] = useState("")
  const [pageLink, setPageLink] = useState("")

  const [anchorsList, setAnchorsList] = useState([])
  const [anchor, setAnchor] = useState("")

  const [linkNameError, setLinkNameError] = useState(false);
  const [requiredError, setRequiredError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [urlError, setUrlError] = useState(false)

  const [useSocial, setUseSocial] = useState(false);
 const [language, setLanguage] = useState("");
  const [saving, setSaving] = useState(false);

  const layout = useSelector(state => state.present.layout);
  const layoutTitle = useSelector(state => state.present.layoutTitle);
  const dispatch = useDispatch();

  useEffect(() => {
    setLinkName(props.LinkName)
    setLink(props.Link || null);
    setLinkType(props.LinkType);

    setEmailLink(props.LinkType == "email" ? props.Link : "");
    setPageLink(props.LinkType == "pageLink" ? props.Link : "");
    setUrlLink(props.LinkType == "url" ? props.Link : "");
    setAnchor(props.LinkType == "anchor" ? props.Link : "");

    setUseSocial(props.UseSocial);
    setLinkOpen(props.LinkOpen)
  }, [props.LinkName, props.Link, props.LinkType, props.UseSocial, props.LinkOpen]);

  useEffect(() => {
    if (props.layout) {
      setAnchorsList(filterLayout(props.layout, 'Row'))
    }
  }, [props.layout])

  const linkTypeChange = (e) => {
    const { value } = e.target;
    setLinkType(value);
    if (value === 'e2af' || value === 'response' || value === 'attach') {
      setLink("");
    } else {
      const getValue = {
        "email": emailLink,
        "pageLink": pageLink,
        "url": urlLink,
        "attach": urlLink,
        "anchor": anchor
      }
      setLink(getValue[value])
    }
  };

  const linkChange = (e) => {
    const { value } = e.target;
    setLink(value);
    const setValue = {
      "email": setEmailLink,
      "pageLink": setPageLink,
      "url": setUrlLink,
      "attach": setUrlLink,
      "anchor": setAnchor
    }
    setValue[linkType](value)
  };


  const switchState = (func) => {
    func(true);
    setTimeout(() => {
      func(false)
    }, 5000);
  }

  const handleSave = () => {
    if (!link && linkType !== 'e2af' && linkType !== 'response') return switchState(setRequiredError);
    if (!linkName) return switchState(setLinkNameError);
    if (linkType === 'email' && !validateEmailFormat(link)) return switchState(setEmailError);
    if (linkType === 'url' && !validateURLFormat(link)) return switchState(setUrlError);
    setSaving(true);
    const idToPush = props.ID;
    const parsedLayout = JSON.parse(JSON.stringify(layout));
    let currentLinkType = linkType === 'attach' ? 'url' : linkType;



    const newLayout = UTILS.UpdateLayout(
      parsedLayout,
      props.ID,
      (item) => {
         item.linktype = currentLinkType;
         item.use_social = useSocial;
         item.language = language;
         item.link = link;
         item.linkopen = linkOpen;
         item.linkname = linkName;
      },
      (colItem) => {
           colItem.linktype = currentLinkType;
           colItem.use_social = useSocial;
           colItem.language = language;
           colItem.link = link;
           colItem.linkopen = linkOpen;
           colItem.linkname = linkName;
      },
      (colItemNested) => {
         colItemNested.linktype = currentLinkType;
         colItemNested.use_social = useSocial;
         colItemNested.language = language;
         colItemNested.link = link;
         colItemNested.linkopen = linkOpen;
         colItemNested.linkname = linkName;
      }
    );
 
    dispatch(actionTypes.layout({ titleLayout: layoutTitle, layout: newLayout }));
    switchState(setSaving);
    setTimeout(() => {
      props.closePopup();
    }, 1200);
  };

  return (
    <div>
      <LinkName name={linkName} setName={setLinkName} error={linkNameError} />
      <Title value="Link Target" />
      <LinkTarget linkOpen={linkOpen} setLinkOpen={setLinkOpen} />
      <Title value="Link Type" />
      <div className="modalContentWrapper">
        <LinkToPage
          link={pageLink}
          onLinkChange={linkChange}
          type={linkType}
          onTypeChange={linkTypeChange}
          pagesList={props.pagesList}
        />

        <LinkUrl
          link={urlLink}
          onLinkChange={linkChange}
          type={linkType}
          onTypeChange={linkTypeChange}
          error={urlError}
        />

        <LinkEmail
          link={emailLink}
          onLinkChange={linkChange}
          type={linkType}
          onTypeChange={linkTypeChange}
          error={emailError}
        />

        <Email2AFriend
          useSocial={useSocial}
          setUseSocial={setUseSocial}
          type={linkType}
          onTypeChange={linkTypeChange}
        />

        <LinkToResponse type={linkType} onTypeChange={linkTypeChange} />

        <AttachFile
          type={linkType}
          onTypeChange={linkTypeChange}
          onLinkChange={linkChange}
        />

        <AddAnchor
          link={anchor}
          onLinkChange={linkChange}
          type={linkType}
          onTypeChange={linkTypeChange}
          anchorsList={anchorsList}
        />

        <ErrorMessage
          text="Please select a link type and give it a value."
          condition={requiredError}
        />
        <ErrorMessage
          text="Please enter a name for your link."
          condition={linkNameError}
        />

        <Footer
          title="Save Link"
          confirmMessage={'Are you sure you want to save these link settings?'}
          isSaving={saving}
          onSave={handleSave}
          onCancel={props.closePopup}
        />
      </div>
    </div>
  );
};

export default LinkOption;